import type { QueryClient } from "@tanstack/react-query";
import type { MarkDraft } from "@/lib/api/assignments";

/** The marker's private draft of one attempt, as last read or saved. */
export const markDraftKey = (submissionId: string) => ["mark-draft", submissionId] as const;

/** A private save on its way, per attempt, so a record waits for its answer. */
const saving = new Map<string, Promise<void>>();

export function trackMarkDraftSave(submissionId: string, save: Promise<void>) {
  saving.set(submissionId, save);
  void save.finally(() => { if (saving.get(submissionId) === save) saving.delete(submissionId); });
}

/** The private draft revision a record closes: the latest saved, once a save on its way has answered. */
export async function savedMarkRevision(client: QueryClient, submissionId: string): Promise<number | null> {
  await saving.get(submissionId);
  return client.getQueryData<{ draft: MarkDraft | null }>(markDraftKey(submissionId))?.draft?.revision ?? null;
}
